import React from "react";
import "./Banner.css";
function Banner() {
  return (
    <div className="banner" id="/scroll__banner">
      <div className="banner__info">
        <h2>I am Synthetically</h2>
        <h2 className="banner__creative">Creative.</h2>
        <h3>Professional FullStack Web developer</h3>
        <h4>Online Mentor , CS student, having keen interest in startups</h4>
      </div>
      <div className="banner__pofile">
        <img src="/design.png" />
      </div>
    </div>
  );
}

export default Banner;
